import React, { useState, useEffect, useRef, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { get } from '../../lib/storage'
import { Consumer } from '../../context/editorContext'
import LogoutIcon from '../Images/LogoutIcon'
import WalletIcon from '../Images/WalletIcon'
import AuthorBadge from '../Images/AuthorBadge'
import HomeIcon from '../Images/HomeIcon'
import BackIcon from '../Images/BackButton'
import PencilIcon from '../Images/PencilIcon'
import NovelsIcon from '../Images/NovelsIcon'
import BrandLogoIcon from '../Images/BrandLogoIcon'
import BellIcon from '../Images/BellIcon'
import CaretDown from '../Images/CaretDown'
import PenIcon from '../Images/Pen'
import { convertUrlToHttps, handleEventLog } from '../../lib/utils'
import {
  Main,
  NavSideDrawer,
  NavList,
  NavListItem,
  NavItemIcon,
  NavItemText,
  NavIconContainer,
  NavButton,
  NavHeader,
  ProfileContainer,
  ProfileImgContainer,
  ProfileImg,
  ProfileName,
  ProfileListItem,
  ProfileMenuList,
  ProfileWalletContainer,
  MobileNavListItem,
  MobileNavList,
  MobileNavItemIcon,
  MobileNavItemText,
  HeaderContainer,
  NotificationBellContainer,
  NotificationCount,
  UserProfileContainer,
  BadgeProfileContainer,
  BadgeProfileImg,
  BadgeText,
  BadgeProfileListItem,
  BadgeImg,
  NewVipIcon,
} from './styles'
import { NotificationsContext } from '../../providers/notificationsProvider'
import { ControlsContext } from '../../providers/controlsProvider'
import Analytics from '../Images/Analytics'
import Academy from '../Images/Academy'
import { AccountContext } from '../../providers/accountProvider'
import { defaultImageUrl } from '../../constants'
import { handleNewEventLog } from '../../lib/utils/events'
import PlusWithFilledCircle from '../Images/PlusWithFilledCircle'

const mobileBreakPoint = 960 // 600px viewport width breakpoint

const navItemIconArray = [
  { name: 'home', icon: <HomeIcon width="20" height="20" /> },
  { name: 'novels', icon: <NovelsIcon width="20" height="20" /> },
  { name: 'my-creations', icon: <PlusWithFilledCircle width="20" height="20"/> },
  { name: 'writers-benefit', icon: <PenIcon width="20" height="20" /> },
  { name: 'income', icon: <WalletIcon width="20" height="20" /> },
  { name: 'analytics', icon: <Analytics width="20" height="20" /> },
  { name: 'Writer’s Academy', icon: <Academy width="20" height="20" /> },
]

const badgeIconObj = {
  l1: '/images/l1.svg',
  l2: '/images/l2.svg',
  certified: '/images/contracted.svg',
  rising_star: '/images/rising.svg',
  pro: '/images/pro.svg',
  silver: '/images/silver.svg',
  gold: '/images/gold.svg',
  platinum: '/images/platinum.svg',
}

const AuthorTierNotionPageHindi =
  'https://pocketnovel.notion.site/Writer-Advancement-Program-74383e57f29348f4b5d01d0053717ee6?pvs=4'
const AuthorTierNotionPageEnglish =
  'https://pocketnovel.notion.site/pocketnovel/Writer-Advancement-Program-d5c3c8c562784379a631126757b559fb'

const NavigationBarAndDrawer = ({
  history,
  location,
  children,
  menuItemsArray = [],
  isProfileNameShown = true,
  analytics_tab = false,
  tabFilterOnLanguageBasis = true,
  authorLanguage,
  authorLocation,
  badge,
}) => {
  const profileImage = convertUrlToHttps(get('image_url'))
  const { user, isUgcUser, isHindiUgcUser } = useContext(AccountContext)
  const { changeNavZIndex } = useContext(ControlsContext)
  const profileName = user.fullname || ''
  // const isSideDrawerVisible = get("isSideDrawerVisible") ? (get("isSideDrawerVisible") === "true") : true
  const hasIncomePath = location.pathname.includes('income')
  const hasNotificationsPath = location.pathname.includes('notifications')
  const hasAddEditChapterPath =
    location.pathname.includes('edit-chapter') ||
    location.pathname.includes('add-chapter')
  const userProfileRef = useRef()
  const [isProfileMenuVisible, setIsProfileMenuVisible] = useState(false)
  // const [isNavSideDrawerVisible, setIsNavSideDrawerVisible] = useState(isSideDrawerVisible)
  const [isMobileView, setIsMobileView] = useState(
    window.innerWidth < mobileBreakPoint
  )
  const process = sessionStorage.getItem('process')
  const { count } = useContext(NotificationsContext)

  const { isAlertsShown, toggleIsAlertsShown } = useContext(ControlsContext)

  const hideProfileMenuHandler = (e) => {
    if (!userProfileRef) return
    if (!userProfileRef.current) return
    if (!userProfileRef.current.contains(e.target))
      setIsProfileMenuVisible(false)
  }

  const resizeWindowHandler = () =>
    setIsMobileView(window.innerWidth < mobileBreakPoint)

  useEffect(() => {
    window.addEventListener('click', hideProfileMenuHandler)
    window.addEventListener('resize', resizeWindowHandler)
    return () => {
      window.removeEventListener('click', hideProfileMenuHandler)
      window.removeEventListener('resize', resizeWindowHandler)
    }
  }, [])

  const handleLabel = (l) => {
    if (l === 'Novels' && isUgcUser) return 'Series'
    return l
  }

  const handleNavClick = (label) => {
    if (label === 'novels') {
      handleNewEventLog(
        'nav_bar',
        'novels_novels_listing_page_clicked',
        {
          route: window.location.pathname + window.location.search,
          module_name: 'nav_bar',
        },
        user
      )
    } else if (label === 'home') {
      handleNewEventLog(
        'nav_bar',
        'writer_home_home_page_clicked',
        {
          route: window.location.pathname + window.location.search,
          module_name: 'nav_bar',
        },
        user
      )
    }
  }

  const generateDesktopNavList = (menuItem, index) => {
    if(menuItem.slug === "analytics" && !analytics_tab) return <></> ;
    if(menuItem.slug === "writers-benefit" && !tabFilterOnLanguageBasis) return <></>;
    if(menuItem.slug === "writer’s academy"  && authorLanguage !== 'hindi') return <></>;
    if (menuItem.slug === 'novels' && isHindiUgcUser)
      return <></>
    if (menuItem.slug === 'my-creations' && !isHindiUgcUser)
      return <></>
    const hasSubMenu  = menuItem?.submenu?.length > 0
    return (
    <NavListItem key={index} to={ !hasSubMenu && menuItem.link} activeClassName={!hasSubMenu && "active"} as={hasSubMenu && "div"} onClick={() =>handleNavClick(menuItem.slug)}>
      <NavItemIcon>{navItemIconArray[index]?.icon}</NavItemIcon>
      <NavItemText>{handleLabel(menuItem.label)}</NavItemText>
      {hasSubMenu && menuItem.submenu.map((subMenuItem,i) => 
      (<NavListItem key={i} to={subMenuItem.link} activeClassName="active">
        <NavItemText>{subMenuItem.label}</NavItemText>
      </NavListItem>) 
      )}
    </NavListItem>)
  }

  const generateMobileNavList = (menuItem, index) => {
    if(menuItem.slug === "income" || menuItem.slug === "analytics" || menuItem?.submenu?.length > 0) return <></>
    if(menuItem.slug === "writers-benefit" && !tabFilterOnLanguageBasis) return <></>;
    if(menuItem.slug === "writer’s academy"  && authorLanguage !== 'hindi') return <></>;
    if (menuItem.slug === 'novels' && isHindiUgcUser)
      return <></>
    if (menuItem.slug === 'my-creations' && !isHindiUgcUser) return <></>
    return (
      <MobileNavListItem key={index} to={menuItem.link} activeClassName="active" onClick={() =>handleNavClick(menuItem.slug)}>
        <MobileNavItemIcon>{navItemIconArray[index]?.icon}</MobileNavItemIcon>
        <MobileNavItemText>{handleLabel(menuItem.label)}</MobileNavItemText>
      </MobileNavListItem>
    )
  }

  const desktopNavList = menuItemsArray.map(generateDesktopNavList)

  const mobileNavList = menuItemsArray.map(generateMobileNavList)

  const toggleProfileMenuHandler = () =>
    setIsProfileMenuVisible((prevValue) => !prevValue)

  const goBackHandler = () => {
    console.log('back button pressed')
    if (
      (window.Android && history?.location?.hash === '#redirectFromLogin') ||
      process === 'continue-writing ' ||
      process === 'create-new' ||
      sessionStorage.getItem('campaign')?.includes('bingerinvite')
    ) {
      if (window.Android.closePage) {
        console.log('Executed closePage')
        window.Android.closePage()
      }
    }
    if (window.Android && history?.location?.hash === '#redirectFromLogin') {
      if (window.Android.onBackPressed) {
        console.log('Executed onBackPressed')
        window.Android.onBackPressed()
      }
    } else if (
      window.webkit &&
      history?.location?.hash === '#redirectFromLogin'
    ) {
      if (
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.writerBackPressed
      ) {
        console.log('writerBackPressed webkit.messageHandlers')
        window.webkit.messageHandlers.writerBackPressed.postMessage(
          'writerBackPressed'
        )
      }
    } else history.goBack()
  }

  const goToHomeHandler = () => history.push('/home')

  const goToIncomeHandler = () => history.push('/income')

  // const goToNotificationHandler = () => history.push("/notifications")

  const generateNavHeader = (editorControlsComponents) => (
    <>
      <HeaderContainer>
        {isMobileView ? (
          !hasAddEditChapterPath && (
            <NavIconContainer>
              <NavButton onClick={goBackHandler} title="Back">
                <BackIcon />
              </NavButton>
              <BrandLogoIcon onClick={goToHomeHandler} title="Pocket Writer" />
            </NavIconContainer>
          )
        ) : (
          <NavIconContainer>
            {!hasAddEditChapterPath && (
              <NavButton onClick={goBackHandler} title="Back">
                <BackIcon />
              </NavButton>
            )}
            {!hasAddEditChapterPath && (
              <BrandLogoIcon onClick={goToHomeHandler} title="Pocket Writer" />
            )}
          </NavIconContainer>
        )}
        {editorControlsComponents()}
        {!hasAddEditChapterPath && isProfileNameShown && (
          <ProfileContainer>
            <NotificationBellContainer
              count={count}
              isActive={hasNotificationsPath}
              onClick={() => toggleIsAlertsShown(!isAlertsShown)}
            >
              <BellIcon />
              {count > 0 && (
                <NotificationCount>
                  {count > 99 ? '99+' : count}
                </NotificationCount>
              )}
            </NotificationBellContainer>
            {isMobileView && !hasAddEditChapterPath && (
              <ProfileWalletContainer
                isActive={hasIncomePath}
                onClick={goToIncomeHandler}
              >
                <WalletIcon />
              </ProfileWalletContainer>
            )}
            <UserProfileContainer
              onClick={toggleProfileMenuHandler}
              ref={userProfileRef}
            >
              {isMobileView && badge && (
                <BadgeText>{badge?.split('_').join(' ')}</BadgeText>
              )}
              {!badge ? (
                <ProfileImgContainer>
                  {profileImage && (
                    <ProfileImg
                      src={profileImage}
                      alt="Writer Avator"
                      onError={(e) => {
                        e.target.src = defaultImageUrl
                      }}
                    />
                  )}
                </ProfileImgContainer>
              ) : (
                <BadgeProfileContainer>
                  <BadgeImg src={badgeIconObj[badge]} />
                  {profileImage && (
                    <BadgeProfileImg src={profileImage} alt="Writer Avator" />
                  )}
                  {!isMobileView && (
                    <BadgeText>{badge?.split('_').join(' ')}</BadgeText>
                  )}
                </BadgeProfileContainer>
              )}

              {!isMobileView && <ProfileName>{profileName}</ProfileName>}
              {!isMobileView && <CaretDown width="15" height="15" />}
              <ProfileMenuList isVisible={isProfileMenuVisible} badge={badge}>
                {badge && (
                  <BadgeProfileListItem
                    href={
                      authorLanguage === 'hindi'
                        ? AuthorTierNotionPageHindi
                        : AuthorTierNotionPageEnglish
                    }
                    target="_blank"
                    onClick={() =>
                      handleEventLog('author_tier', 'button_click', {
                        route:
                          window.location.pathname + window.location.search,
                        button: 'menu_author_tier_button',
                      })
                    }
                  >
                    <NewVipIcon />
                    <AuthorBadge width="20" height="20" />
                    <span>Author Tier</span>
                  </BadgeProfileListItem>
                )}
                <ProfileListItem to="/edit-profile">
                  <PencilIcon width="20" height="20" />
                  <span>Edit Profile</span>
                </ProfileListItem>
                {window.screen.width < 600 && analytics_tab && (
                  <ProfileListItem to="/analytics">
                    <Analytics width="20" height="20" />
                    <span>Analytics</span>
                  </ProfileListItem>
                )}
                <ProfileListItem to="/logout">
                  <LogoutIcon width="20" height="20" />
                  <span>Logout</span>
                </ProfileListItem>
              </ProfileMenuList>
            </UserProfileContainer>
          </ProfileContainer>
        )}
      </HeaderContainer>
      {isMobileView && !hasAddEditChapterPath && (
        <MobileNavList>{mobileNavList}</MobileNavList>
      )}
    </>
  )

  return (
    <Consumer>
      {(editorControlsComponents) => (
        <>
          <NavHeader
            hasAddEditChapterPath={hasAddEditChapterPath}
            changeNavZIndex={changeNavZIndex}
          >
            {generateNavHeader(editorControlsComponents)}
          </NavHeader>
          <NavSideDrawer isVisible={!hasAddEditChapterPath}>
            <NavList>{desktopNavList}</NavList>
          </NavSideDrawer>
          <Main
            hasAddEditChapterPath={hasAddEditChapterPath}
            isMobileView={isMobileView}
          >
            {children}
          </Main>
        </>
      )}
    </Consumer>
  )
}

export default withRouter(NavigationBarAndDrawer)
